import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab, Nav } from "react-bootstrap";
import {
  get_Gemstione_Cart,
  get_BlogSingleData,
} from "../../../store/actions/CommanAction";
import { useDispatch, useSelector } from "react-redux";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import { SET__Gemstone_ID } from "../../../store/Action_Types";
import Loader from "../Loader/Loader";

const GemstoneCartList = () => {
  const dispatch = useDispatch();
  const GemstoneCartList = useSelector(
    (state) => state.feedBackReducer.GemstoneCartList
  );
  const customerID = Number(sessionStorage.getItem("ID"));
  const [IsActive, setIsActive] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setloading] = useState(false);

  useEffect(() => {
    if (IsActive) {
      dispatch(get_Gemstione_Cart("1", setloading));
    } else {
      dispatch(get_Gemstione_Cart("0", setloading));
    }
  }, [IsActive, IsActive]);

  const filterCartData = GemstoneCartList?.filter((item) => {
    const query = searchQuery ? searchQuery.toLocaleLowerCase() : "";
    return (
      (item.HeadingDescription &&
        item.HeadingDescription.toLocaleLowerCase().includes(query)) ||
      (item?.CartID &&
        String(item.CartID).toLocaleLowerCase().includes(query)) ||
      (item.GemstoneID &&
        String(item.GemstoneID).toLocaleLowerCase().includes(query)) ||
      (item.UserID && String(item.UserID).toLocaleLowerCase().includes(query))
    );
  });



  const handleToggleStatusClick = async (
    GemstoneID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      GemstoneID: GemstoneID,
      DeleteByUser: customerID,
      IsActive: !currentStatus ? "1" : "0",
    };
    await AddUpdate("Gemstone/Delete_Gemstone", postData);
    dispatch(get_Gemstione_Cart(currentStatus ? "1" : "0", setloading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };

  const columns = [
    {
      name: "Heading",

      cell: (row) => (
        <div className="concierge-bx d-flex align-items-center">
          <div>
            <h5 className="fs-16 mb-0 text-nowrap">{row.HeadingDescription}</h5>
          </div>
        </div>
      ),
      sortable: true,
    },
   
    {
      name: "Image1",
      cell: (row) => (
        <div className="concierge-bx d-flex align-items-center">
          {row.Image1 ? (
            <img
              className="me-3 rounded"
              src={`https://${row.Image1.replace(/\\/g, "/")}`}
              alt="User Avatar"
            />
          ) : (
            <span className="me-3 rounded">No Photo</span>
          )}
        </div>
      ),
      sortable: true,
    },

    {
      name: "ShortDescription",
      selector: (row) => row.ShortDescription,
      sortable: true,
      format: (row) => (
        <>
          {row?.ShortDescription ? row?.ShortDescription.substring(0, 50) : ""}
          {row?.ShortDescription?.length > 40 ? "  . . ." : null}{" "}
        </>
      ),
    },
    {
      name: "UserName",
      selector: (row) => row.UserName,
      sortable: true,
      format: (row) => (
        <>
          {row?.UserName ? row?.UserName : ""}
          {row?.UserName?.length > 40 ? "  . . ." : null}{" "}
        </>
      ),
    },

    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(row.GemstoneID, true, "0");
                }}
              >
                Inactive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      name: "Heading",
      cell: (row) => (
        <div className="concierge-bx d-flex align-items-center">
          <div>
            <h5 className="fs-16 mb-0 text-nowrap">{row.HeadingDescription}</h5>
          </div>
        </div>
      ),
      sortable: true,
    },

   

    {
      name: "Image1",
      cell: (row) => (
        <div className="concierge-bx d-flex align-items-center">
          {row.Image1 ? (
            <img
              className="me-3 rounded"
              src={`https://${row.Image1.replace(/\\/g, "/")}`}
              alt="User Avatar"
            />
          ) : (
            <span className="me-3 rounded">No Photo</span>
          )}
        </div>
      ),
      sortable: true,
    },

    {
      name: "ShortDescription",
      selector: (row) => row.ShortDescription,
      sortable: true,
      format: (row) => (
        <>
          {row?.ShortDescription ? row?.ShortDescription.substring(0, 50) : ""}
          {row?.ShortDescription?.length > 40 ? "  . . ." : null}{" "}
        </>
      ),
    },
    {
      name: "UserName",
      selector: (row) => row.UserName,
      sortable: true,
      format: (row) => (
        <>
          {row?.UserName ? row?.UserName : ""}
          {row?.UserName?.length > 40 ? "  . . ." : null}{" "}
        </>
      ),
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(row.GemstoneID, false, "1");
                }}
              >
                Activate
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <>
    
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
          <div className="card-action coin-tabs mb-2">
            <Nav variant="tabs">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className={`nav-link ${IsActive ? "active" : ""}`}
                  onClick={() => {
                    setIsActive(true);
                    setSearchQuery("");
                  }}
                >
                  Active
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className={`nav-link ${!IsActive ? "active" : ""}`}
                  onClick={() => {
                    setIsActive(false);
                    setSearchQuery("");
                  }}
                >
                  Inactive
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="input-group search-area text-end">
            <input
              type="text"
              className={`form-control text-dark`}
              placeholder="Search Astrologers..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <span className="input-group-text">
              <Link to={"#"}>
                <i className="flaticon-381-search-2"></i>
              </Link>
            </span>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="table-responsive">
                      {IsActive ? (
                        <>
                          {loading ? (
                            <Loader />
                          ) : (
                            <DataTable
                              dense
                              data={filterCartData}
                              columns={columns}
                              selectableRowsHighlight
                              highlightOnHover
                              pagination
                              persistTableHead={true}
                              noDataComponent={"There are no data to display"}
                              customStyles={customStyles}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {loading ? (
                            <Loader />
                          ) : (
                            <DataTable
                              dense
                              data={filterCartData}
                              columns={columns1}
                              selectableRowsHighlight
                              pagination
                              persistTableHead={true}
                              noDataComponent={"There are no data to display"}
                              customStyles={customStyles}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default GemstoneCartList;
